import React, {useEffect, useState} from "react";
import {TabPanel, TabView} from 'primereact/tabview';
import {Link} from "react-router-dom";
import {SubscribedCourseService} from "../../service/SubscribedCourseService";
import BreadcrumbThree from "../../components/breadcrumb/breadcrumb-3";
import CourseTypeOne from "../../components/course/course-type-one";

const MyCourses = () => {

    const [data, setData] = useState([]);

    const service = new SubscribedCourseService();

    useEffect(() => {
        // service.checkPage();
        service.findAll().then(response => {
            setData(response);
        });
    }, []);

    const optionsComps = [
        <>
            <Link to="/">
                Test
            </Link>
            <Link to="/">
                Test 2
            </Link>
        </>
    ];


    return (
        <>
            <BreadcrumbThree title="Öğrenim İçeriğim" subtitle="" />
            <div className="container">
                {/*<TabView style={{width: "100%"}}>*/}
                {/*    <TabPanel header="Tüm Kurslar">*/}

                <div className="row g-5 p-4">
                    {data?.map((row, index) =>
                        <div key={index} className="col-md-6 col-xl-3">
                            <CourseTypeOne key={index} data={row.course} isSubscribed={true}
                                           classes="course-box-shadow"/>
                        </div>)}
                </div>

                {/*        <div className="my-course-card-grid">*/}
                {/*        {data?.map((row, index) => <CourseCard key={index} data={row.course} isSubscribed={true}/>)}*/}
                {/*        </div>*/}
                {/*    </TabPanel>*/}
                {/*    <TabPanel header="Arşivlenen">*/}
                {/*        <div className="my-course-card-grid">*/}
                {/*            {data?.map((row, index) => {*/}
                {/*                if(row.isArchived) {*/}
                {/*                    return (<CourseCard key={index} data={row.course} isSubscribed={true}/>);*/}
                {/*                }*/}
                {/*            })}*/}
                {/*        </div>*/}
                {/*    </TabPanel>*/}
                {/*    /!*<TabPanel header="Öğrenim Yolları"></TabPanel>*!/*/}
                {/*    /!*<TabPanel header="Öğrenim Araçları"></TabPanel>*!/*/}
                {/*</TabView>*/}
            </div>
        </>

    );
};

export default MyCourses;
